/**
 * useFavourites
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import FavouritesContext from './favourites-context'

const useFavourites = () => {
  const context = useContext(FavouritesContext)
  return context
}

export default useFavourites
